<template>
    <div class="battles-bet-element" v-bind:class="{ 
        'element-winner': battlesGameData.game.state === 'completed' && bet.payout > 0, 
        'element-lost': battlesGameData.game.state === 'completed' && bet.payout <= 0 
    }">
        <div class="element-top">
            <div class="top-inner">

                <div v-if="bet !== null" class="inner-info">
                    <div class="info-user" v-bind:class="[
                        'user-' + (bet.bot === true ? 'bot' : battlesGetRank(bet.user)),
                        'user-' + battlesGetLevelColor(bet.user)
                    ]">
                        <div class="user-avatar">
                            <AvatarImage v-bind:image="bet.bot ? null : bet.user.avatar" />
                        </div>
                        <span v-html="bet.bot === true ? battlesGetBotName : bet.user.username"></span>
                    </div>
                    <div class="info-amount">
                        <img src="@/assets/img/rivocoin.png" alt="icon" />
                       <div class="amount-value">
    {{ formatFiat(battlesGetOutcomeAmount) }}
</div>

                    </div>
                </div>
                <div v-else class="inner-actions">
                    <div v-if="battlesGameData.game.options.funding > 0" class="actions-funding">
                        <div class="funding-inner">
                            <span>-{{ battlesGameData.game.options.funding }}%</span>
                        </div>
                    </div>

                    <button v-on:click="authUser.user !== null && authUser.user._id === battlesGameData.game.bets[0].user._id ? battlesBotButton() : battlesJoinButton()" class="button-join" v-bind:disabled="socketSendLoading !== null">
                        <div class="button-inner">
                            <transition name="fade" mode="out-in">
                                <ButtonLoading v-if="socketSendLoading === 'BattlesJoin' || socketSendLoading === 'BattlesCall'" />
                                <div v-else class="inner-content">
                                    <div v-if="authUser.user !== null && authUser.user._id === battlesGameData.game.bets[0].user._id" class="content-bot">
                                        <img src="@/assets/img/knight.png" />
                                    </div>
                                    <svg v-else width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.47861 8.33238L6.15342 11.0087L5.08395 12.0789L6.15493 13.1499L5.08471 14.2201L3.21144 12.3469L1.07023 14.4881L0 13.4178L2.14121 11.2759L0.267935 9.40336L1.33816 8.33313L2.40839 9.4026L3.47861 8.33238ZM0.413256 0.456299L3.09715 0.458569L12.0412 9.40336L13.1122 8.33313L14.1824 9.40336L12.3099 11.2766L14.4503 13.4178L13.3801 14.4881L11.2389 12.3469L9.36561 14.2201L8.29539 13.1499L9.36561 12.0789L0.415526 3.12884L0.413256 0.456299ZM11.3554 0.456299L14.0371 0.458569L14.0386 3.12505L10.971 6.19192L8.29463 3.51636L11.3554 0.456299Z" />
                                    </svg>

                                    {{ authUser.user !== null && authUser.user._id === battlesGameData.game.bets[0].user._id ? 'CALL BOT' : 'JOIN BATTLE' }}
                                </div>
                            </transition>
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <div class="element-items">
            <div class="items-list">

                <BattlesItemElement v-for="(item, index) in battlesGetOutcomeItems" v-bind:key="index" v-bind:item="item" />
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { useCurrency } from '@/composables/useCurrency'

import AvatarImage from '@/components/AvatarImage'
import ButtonLoading from '@/components/ButtonLoading'
import BattlesItemElement from '@/components/battles/BattlesItemElement'

export default {
    name: 'BattlesBetElement',
    components: {
        AvatarImage,
        ButtonLoading,
        BattlesItemElement
    },
    props: [
        'pos',
        'bet'
    ],
    setup() {
        const { formatFiat } = useCurrency()
        return { formatFiat }
    },
    methods: {
        ...mapActions([
            'notificationShow',
            'battlesSendBotSocket',
            'battlesSendJoinSocket'
        ]),
        battlesGetRank(user) {
            let rank = user.rakeback
            if (user.rank !== 'user') rank = user.rank
            return rank
        },
        battlesGetLevelColor(user) {
            if (user.level >= 100) return 'purple'
            if (user.level >= 76) return 'red'
            if (user.level >= 51) return 'orange'
            if (user.level >= 26) return 'green'
            if (user.level >= 2) return 'blue'
            return ''
        },
        battlesGetItemsFormated(items) {
            let pos = 0

            for (let item of items) {
                pos += item.tickets

                if (pos < 999) item.color = 'yellow'
                else if (pos < 4999) item.color = 'red'
                else if (pos < 19999) item.color = 'green'
                else if (pos < 49999) item.color = 'purple'
                else item.color = 'blue'
            }

            return items
        },
        battlesBotButton() {
            this.battlesSendBotSocket({
                gameId: this.battlesGameData.game._id
            })
        },
        battlesJoinButton() {
            if (this.authUser.user === null) {
                this.notificationShow({
                    type: 'error',
                    message: 'Please sign in to perform this action.'
                })
                return
            }

            this.battlesSendJoinSocket({
                gameId: this.battlesGameData.game._id,
                slot: this.pos
            })
        }
    },
    computed: {
        ...mapGetters([
            'socketSendLoading',
            'authUser',
            'battlesGameData'
        ]),
        battlesGetBotName() {
            if (this.pos === 3) return 'Redcliff Sr.'
            if (this.pos === 2) return 'Redcliff Jr.'
            return 'Redcliff'
        },
        battlesGetBoxes() {
            let boxes = []

            if (this.battlesGameData.game !== null) {
                for (const box of this.battlesGameData.game.boxes) {
                    for (let i = 0; i < box.count; i++) {
                        boxes.push(box.box)
                    }
                }
            }

            return boxes
        },
        battlesGetOutcomeItems() {
            let items = []

            if (this.bet !== null) {
                const outcomes =
                    this.battlesGameData.game.state === 'completed'
                        ? this.bet.outcomes
                        : this.bet.outcomes.slice(0, -1)

                for (const [index, outcome] of outcomes.entries()) {
                    let pos = 0

                    for (const item of this.battlesGetItemsFormated(
                        this.battlesGetBoxes[index].items
                    )) {
                        pos += item.tickets
                        if (outcome <= pos) {
                            items.push(item)
                            break
                        }
                    }
                }
            }

            return items.reverse()
        },
        battlesGetOutcomeAmount() {
            let amount = 0
            for (const item of this.battlesGetOutcomeItems) {
                amount += item.item.amountFixed // 🔴 USD BASE
            }
            return amount
        }
    }
}
</script>


<style scoped>
    .battles-bet-element {
        width: calc(50% - 9px);
    }

    .battles-game.game-3 .battles-bet-element {
        width: calc(33.33% - 10px);
    }

    .battles-game.game-4 .battles-bet-element {
        width: calc(25% - 4.5px);
    }

    .battles-bet-element .element-top {
        width: 100%;
        height: 65px;
        margin-bottom: 15px;
        padding: 1px;
        background: #0a273f;
    }

    .battles-bet-element.element-winner .element-top {
        background: linear-gradient(270deg, rgba(1, 229, 168, 0.7) 0%, rgba(0, 0, 0, 0) 45%), #0a273f;
    }

    .battles-bet-element.element-lost .element-top {
        background: linear-gradient(270deg, rgba(245, 80, 70, 0.7) 0%, rgba(0, 0, 0, 0) 45%), #0a273f;
    }

    .battles-bet-element .top-inner {
        width: 100%;
        height: 100%;
        background: linear-gradient(223deg, rgba(5, 29, 48, 0.35) 0%, rgba(31, 99, 153, 0.1) 50%, rgba(5, 29, 48, 0.35) 100%), #041f35;
    }

    .battles-bet-element.element-winner .top-inner {
        background: linear-gradient(223deg, rgba(1, 232, 171, 0.2) 0%, rgba(0, 0, 0, 0) 50%), 
                    linear-gradient(223deg, rgba(5, 29, 48, 0.35) 0%, rgba(31, 99, 153, 0.1) 50%, rgba(5, 29, 48, 0.35) 100%), #041f35;
    }

    .battles-bet-element.element-lost .top-inner {
        background: linear-gradient(223deg, rgba(235, 42, 42, 0.2) 0%, rgba(0, 0, 0, 0) 50%),
                    linear-gradient(223deg, rgba(5, 29, 48, 0.35) 0%, rgba(31, 99, 153, 0.1) 50%, rgba(5, 29, 48, 0.35) 100%), #041f35;
    }

    .battles-bet-element .inner-info {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
    }

    .battles-bet-element .info-user {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 700;
        color: #ffffff;
    }

    .battles-bet-element.element-winner .info-user span {
        background: var(--button1);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent; 
    }

    .battles-bet-element.element-lost .info-user span {
        color: #f55046;
    }

    .battles-bet-element .user-avatar {
        width: 37px;
        height: 37px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-right: 13px;
        border-radius: 50%;
        border: 2px solid #9e9e9e;
        overflow: hidden;
    }

    .battles-bet-element .info-user.user-blue .user-avatar {
        border: 2px solid #559ee4;
    }

    .battles-bet-element .info-user.user-green .user-avatar {
        border: 2px solid #b8e92d;
    }

    .battles-bet-element .info-user.user-orange .user-avatar {
        border: 2px solid #fca311;
    }

    .battles-bet-element .info-user.user-red .user-avatar {
        border: 2px solid #ff4e4e;
    }

    .battles-bet-element .info-user.user-purple .user-avatar {
        border: 2px solid #6953f1;
    }

    .battles-bet-element .info-user.user-partner .user-avatar {
        border: 2px solid #eca822;
    }

    .battles-bet-element .info-user.user-mod .user-avatar {
        border: 2px solid #ffb703;
    }

    .battles-bet-element .info-user.user-bot .user-avatar,
    .battles-bet-element .info-user.user-admin .user-avatar {
        border: 2px solid #01e0a3;
    }

    .battles-bet-element .user-avatar .avatar-image {
        width: 26px;
        height: 26px;
    }

    .battles-bet-element .info-amount {
        display: flex;
        align-items: center;
    }

    .battles-bet-element .info-amount img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }

    .battles-bet-element .amount-value {
        font-size: 11px;
        font-weight: 600;
        color: #bbbfd0;
    }

    .battles-bet-element .amount-value span {
        font-size: 15px;
        font-weight: 800;
        color: #ffffff;
    }

    .battles-bet-element .inner-actions {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .battles-bet-element .actions-funding {
        width: 48px;
        height: 21px;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translate(0, -50%);
        padding: 1px;
        filter: drop-shadow(0px 1px 15px rgba(1, 230, 169, 0.63));
    }

     

    .battles-bet-element .funding-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(242deg, rgba(0, 255, 194, 0.44) 16%, rgba(0, 231, 170, 0.22) 32%, rgba(0, 218, 157, 0.1) 50%, rgba(0, 195, 134, 0.26) 80%, rgba(0, 170, 109, 0.44) 100%), 
                    linear-gradient(180deg, #073137 0%, #082538 100%);
         
    }

    .battles-bet-element .funding-inner span {
        font-size: 11px;
        font-weight: 800;
        background: linear-gradient(239deg, #01e0a3 -100%, #00aa6d 120%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .battles-bet-element button.button-join {
        width: 150px;
        height: 35px;
        position: relative;
        padding: 1px;
    }

     
    .battles-bet-element button.button-join .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--button1);
        clip-path: polygon(5px 0, calc(100% - 5px) 0, 100% 25%, 100% 75%, calc(100% - 5px) 100%, 5px 100%, 0 75%, 0 25%);
    }

    .battles-bet-element button.button-join .button-loading.fade-leave-active {
        transition: opacity 0.1s;
    }

    .battles-bet-element button.button-join .button-loading.fade-leave-to {
        opacity: 0;
    }

    .battles-bet-element button.button-join .inner-content.fade-enter-active {
        transition: opacity 0.1s;
    }

    .battles-bet-element button.button-join .inner-content.fade-enter {
        opacity: 0;
    }

    .battles-bet-element button.button-join .inner-content {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 800;
        color: #ffffff;
    }

    .battles-bet-element button.button-join .inner-content svg {
        margin-right: 8px;
        fill: #ffffff;
    }

    .battles-bet-element button.button-join .content-bot {
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-right: 6px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.2);
        border: 1px solid #4adeaf;
        overflow: hidden;
    }

    .battles-bet-element button.button-join .content-bot img {
        width: 34px;
        transform: scaleX(-1);
    }

    .battles-bet-element .element-items {
        width: 100%;
        height: 400px;
        padding: 4px;
        overflow-x: scroll;
        border-radius: 5px;
        background: var(--background2);
        border: 1px solid #0a273f;
    }

    .battles-bet-element .items-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    @media only screen and (max-width: 1250px) {

        .battles-game.game-4 .battles-bet-element {
            width: calc(50% - 3px);
        }

        .battles-game.game-4 .battles-bet-element .element-items {
            display: none;
        }

    }

    @media only screen and (max-width: 1150px) {

        .battles-game.game-3 .battles-bet-element {
            width: calc(50% - 3px);
        }

        .battles-game.game-3 .battles-bet-element .element-items {
            display: none;
        }

    }

    @media only screen and (max-width: 850px) {

        .battles-bet-element {
            width: 100%!important;
        }

        .battles-bet-element .element-items {
            display: none;
        }

    }
</style>